import {ISlotsListState,ISlotListActionTypes,ISlotListActionCreator} from 'models/ISlotsListState';

const initialState:ISlotsListState[] = []

const reducer = (state = initialState, { type, payload }: ISlotListActionCreator) => {
    switch (type) {
      case ISlotListActionTypes.FETCH_SLOTS_LIST_REQUEST:
        return {
            ...state,
            data:[],
        }
      case ISlotListActionTypes.FETCH_SLOTS_LIST_SUCCESS:
        return {
          ...state,
          data: payload
        }
      default:
        return state;
    }
  };
  
  export default reducer;